import React, { useEffect, useRef, useState } from "react"
import { v4 } from "uuid"
import { useAxios } from "../../hooks/useAxios"
import { ModalLoader } from "../../ui/modals/ModalLoarer"
import { MainNavigation } from "../../ui/navigations/MainNavigation"
import { GraphView } from "../reports/GraphView"
import { TableView } from "../reports/TableView"
import { BugReportModal } from "./BugReportModal"
import { NotViewedExams } from "./NotViewedExams"
import { useTranslation } from "react-i18next"
import { useLanguage } from "../../hooks/useLanguage"
import { StudentList } from "./StudentList"
import { DashboardContext } from "./DashboardContext"
import { StudentDash } from "./StudentDash"
import { ReportView } from "./ReportView"
import { TabsView } from "./TabsView"
import { HomeworkView } from "./HomeworkView"

export const Dashboard = () => {
  const api = useAxios()
  useLanguage()
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState()
  const [reportText, setReportText] = useState("")
  const [error, setError] = useState()
  const [students, setStudents] = useState([])
  const [selectedStudentId, setSelectedStudentId] = useState()
  const [studentError, setStudentError] = useState()
  const [student, setStudent] = useState()
  const [semesters, setSemesters] = useState()
  const [exams, setExams] = useState([])
  const [selectedSemesterId, setSelectedSemesterId] = useState()
  const [selectedExamId, setSelectedExamId] = useState()
  const [reportView, setReportView] = useState("graph")
  const [studentLoader, setStudentLoader] = useState(false)
  const [courses, setCourses] = useState([])
  const [studentResponse, setStudentResponse] = useState()
  const [selectedCourseId, setSelectedCourseId] = useState()
  const [showBugReport, setShowBugReport] = useState(false)
  const [notViewedExams, setNotNviewedExams] = useState([])

  const scrollRef = useRef()
  const getStudent = async () => {
    setStudentLoader(true)
    try {
      const response = await api.get(`${process.env.REACT_APP_BACKEND_URL}students?student_id=${selectedStudentId}`)
      setStudent(response?.data.student)
      setSemesters(response?.data.semesters)
      setStudentResponse(response.data)
      setNotNviewedExams(response.data.not_viewed_exams)
      setSelectedSemesterId("")
      setSelectedExamId("")
    } catch (ex) {
      setStudentError(ex?.response?.data.message)
    } finally {
      setStudentLoader(false)
    }
  }

  const dash = async () => {
    setLoading(true)
    try {
      const res = await api.get("dashboard")
      setResponse(res)
    } catch (ex) {
      setError(ex.response.data.errors)
      if (ex?.response?.status === 401) {
        window.location.href = "/"
      }
      console.log(ex.response)
    } finally {
      setLoading(false)
    }
  }

  const filterData = () => {
    const courseIds = []
    if (selectedSemesterId === "") {
      return
    }
    console.log("selectedSemesterId", selectedSemesterId, courseIds)
    const filteredExams = studentResponse.exams.filter((exam) => exam.semester_id == selectedSemesterId)
    const mapedCourses = filteredExams.map((ex) => {
      return {
        id: ex.course_id,
        name: ex.course_name,
      }
    })
    console.log("mapedCourses", mapedCourses)
    const tmpCourses = []
    mapedCourses.forEach((course) => {
      if (!courseIds.includes(course.id)) {
        tmpCourses.push(course)
      }
      courseIds.push(course.id)
    })
    setCourses(tmpCourses)

    if (!selectedCourseId) {
      return
    }
    const tmpExams = studentResponse.exams.filter(
      (exam) => exam.semester_id == selectedSemesterId && exam.course_id == selectedCourseId,
    )
    console.log(tmpExams)
    setExams(tmpExams)
  }

  useEffect(() => {
    if (response) {
      setStudents(response.data.guardian.students)
      setReportText(response.data.report_text)
    }
  }, [response])

  useEffect(() => {
    if (selectedStudentId) getStudent()
  }, [selectedStudentId])

  useEffect(() => {
    dash()
  }, [])

  useEffect(() => {
    if (studentResponse) filterData()
  }, [selectedCourseId, selectedSemesterId])

  return (
    <DashboardContext.Provider
      value={{
        students,
        selectedStudentId,
        setSelectedStudentId,
        student,
        setSelectedSemesterId,
        setSelectedCourseId,
        setSelectedExamId,
        selectedSemesterId,
        selectedCourseId,
        selectedExamId,
        exams,
        courses,
        semesters,
        setReportView,
        reportView,
        t,
      }}>
      <MainNavigation />
      <ModalLoader show={studentLoader} onHide={() => setStudentLoader(false)} />
      <BugReportModal
        show={showBugReport}
        hide={() => setShowBugReport(false)}
        studentId={selectedStudentId}
        examId={selectedExamId}
      />
      {loading && <ModalLoader show={loading} onHide={setLoading(false)} />}
      <div className="mt-3"></div>
      <div className="container">
        <div className="card shadow-sm">
          <div className="card-header d-flex align-items-center justify-content-between">
            <div>Dashboard</div>
            <button className="btn btn-primary" onClick={() => setShowBugReport(true)}>
              {t("report_problem")}
            </button>
          </div>
          <StudentList />
        </div>
        {student && notViewedExams?.length > 0 && (
          <NotViewedExams
            exams={notViewedExams}
            student={student}
            updateSelectedExam={(exam) => {
              setSelectedExamId(exam.id)
              scrollRef.current?.scrollIntoView({ behavior: "smooth" })
            }}
          />
        )}

        <div ref={scrollRef}></div>
        {student && <TabsView />}
      </div>
    </DashboardContext.Provider>
  )
}
